<ng-container *ngIf="addItemForm else loadingView">
    <form [formGroup]="addItemForm" class="cas-flex-row w-100 main-form">
        <input formControlName="id" type="hidden">
        <acabim-form-block
                labelWidth="10"
                [labelAlign]="'right'"
                class="col-md-6"
                [shortFields]="true"
                [colonize]="true">
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Name</acabim-form-input-label>
                <acabim-form-input-content [longField]="true">
                    <input formControlName="name" type="text">
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Code</acabim-form-input-label>
                <acabim-form-input-content>
                    <input formControlName="code" type="text">
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Cost</acabim-form-input-label>
                <acabim-form-input-content>
                    <div>
                        <input formControlName="cost" type="number">
                        <span class="cas-form-units">$</span>
                    </div>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Price</acabim-form-input-label>
                <acabim-form-input-content>
                    <div>
                        <input formControlName="price" type="number">
                        <span class="cas-form-units">$</span>
                    </div>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Account</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-dropdown
                        formControlName="account"
                        [group]="true"
                        [options]="accounts"
                        placeholder="Select Account"></p-dropdown>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Tax</acabim-form-input-label>
                <acabim-form-input-content [longField]="true">
                    <p-dropdown
                        formControlName="taxMethod"
                        [options]="taxMethods"
                        class="push-down-1"
                        placeholder="Select a tax method"></p-dropdown>
                    <p-dropdown
                        formControlName="taxValue"
                        [options]="taxAmounts"

                        class="push-down-1"
                        placeholder="Select a tax amount"></p-dropdown>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
        </acabim-form-block>
    </form>
    <div class="cas-action-buttons cas-action-buttons-bottom">
        <button type="button" (click)="onCancel()">Cancel</button>
        <button
            type="button"
            class="cas-button-action cas-button-right"
            data-cy="_t-add-inventory-submit"
            (click)="onComplete()">Save</button>
    </div>
</ng-container>

<ng-template #loadingView>
    <acabim-loading-view></acabim-loading-view>
</ng-template>
